import axios from "axios";

const API = axios.create({
  baseURL: import.meta.env.VITE_API_URL || "http://localhost:8000",
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

let consecutiveFailures = 0;
const SERVICE_DOWN_THRESHOLD = 3;

API.interceptors.response.use(
  (response) => {
    consecutiveFailures = 0;
    return response;
  },
  (error) => {
    const status = error.response?.status;
    if (status === 503 || status === 502 || status === 500 || error.code === "ERR_NETWORK") {
      consecutiveFailures += 1;
      if (consecutiveFailures >= SERVICE_DOWN_THRESHOLD) {
        window.dispatchEvent(new CustomEvent("service-down", { detail: { status } }));
      }
    } else {
      consecutiveFailures = 0;
    }
    return Promise.reject(error);
  }
);

export default API;
